export const getMetadata = state => state.start.metadata;

export default getMetadata;
